// Override the request body type to accept FormData for multipart/form-data uploads
export type InternalPostExperimentStratifiedSamplingRequestBody = FormData;

export function bodySerializer(body: FormData): FormData {
  return body;
}
